import { CookiesStorageService } from '@/services/cookiesStorageService';
import { COOKIES_KEYS } from '@/constants';

/**
 * Detects the Global Privacy Control (GPC) signal on the client.
 *
 * Priority:
 * 1) server-synchronized signal from middleware (`Sec-GPC` -> cookie),
 * 2) native/browser-extension signal on `navigator.globalPrivacyControl`.
 *
 * The cookie path makes the first decision server-first on initial navigation,
 * while the navigator fallback still supports late client-side injection by
 * extensions and browsers.
 */
export const isGpcSignalPresent = (): boolean => {
	if (typeof window === 'undefined') return false;

	const serverSignal = CookiesStorageService.get<string | number>(
		COOKIES_KEYS.GPC_SIGNAL,
		'',
	);
	if (String(serverSignal).trim() === '1') {
		return true;
	}

	return Boolean(
		(
			window.navigator as Navigator & {
				globalPrivacyControl?: boolean;
			}
		).globalPrivacyControl,
	);
};
